<template>
  <div class="riiqosxn riiqosxn-calendar">
    <v-container>
      <v-row class="row-f">
        <v-col cols="12" md="7">
          <div class="riiqosxn-img"></div>
        </v-col>
        <v-col cols="12" md="5" class="riiqosxn-content">
          <h4 class="title-sm">Google Calendar</h4>
          <p>With a full integration of Google calendars, you can keep what you love. Import or Export Google calendars with the Riiqo system so you don’t miss an appointment.</p>
          <div class="mod-icons">
            <div class="mod-row">
              <div class="mod-row__item calendar"></div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'HomeCalendar',

  data: () => ({
    
  }),
};
</script>
